import React,{useState,useEffect} from 'react'
import sliderCloseIcon from '../../assets/images/slider-close-icon.svg';
import { useDispatch,useSelector } from "react-redux";
import {fetchSilentMessage, fetchSilentChat,createContact,fetchTags,fetchMessages ,setChatPhone,fetchChat} from '../../redux/action';
import  AsyncCreatable from 'react-select/creatable';
import { isPossiblePhoneNumber, isValidPhoneNumber } from 'react-phone-number-input'
import { encodePhoneNumber } from '../../helpers/Utils';
import {Alert} from "reactstrap"
export default function CreateContactSlider({phone=''}) {
    const tags=useSelector((state)=>state.tags)
    const messages=useSelector(state=>state.messages)
    const dispatch=useDispatch()
    const [options,setOptions]=useState([])
    const [validationErrors,setValidationErrors]=useState([])
    const [newContact,setNewContact]=useState({
        first_name:'',
        last_name:'',
        phone_no:phone,
        tags:[{label:"ABC",value:2}]
      })
    
    useEffect(()=>{
        console.log("I am logging"+phone)
        setNewContact({
            first_name:'',
        last_name:'',
        phone_no:phone,
        tags:[]
        })
    },[phone])

    const onSelectChange=(value)=>{
        console.log(value)
        setNewContact({
            ...newContact,tags:value
        })
       }

    const getOptions=()=>{
        let opts=[]
        tags.data.map( item => {
            opts.push({ value: item.id, label: item.tag })
        })
        setOptions([...opts])
      
      }

    const handleSubmit=()=>{
        let errors=[]
        if(newContact.first_name===''){
            errors.push({error:"First Name is Required!"})
        }
        if(newContact.last_name===''){
            errors.push({error:"Last Name is Required!"})
        }
        if(encodePhoneNumber(newContact.phone_no).length<14){
            errors.push({error:"Valid Phone Number is Required!"})

        }
        setValidationErrors(errors)
        if(errors.length===0){
        let newPhone=("1"+newContact.phone_no).replace(/[(+)]/g, '')
        dispatch(createContact({
            first_name:newContact.first_name,
            last_name:newContact.last_name,
            phone_no:newPhone,
            tags:newContact.tags
          }))
          dispatch(fetchSilentMessage())
         // dispatch(setChatPhone(messages.length > 0 && messages.data[0].sender_phone))
          dispatch(fetchSilentChat())
          clearData()
          setValidationErrors([])

        }

    }

    useEffect(()=>{
        getOptions()
       
      },[])

      const clearData=()=>{
        setNewContact({
            first_name:'',
        last_name:'',
        phone_no:'',
        tags:[]
        })
      }

      const handleNewContact=(e)=>{
        const key=e.target.name;
        const value=e.target.value;
       
        setNewContact({
         ...newContact,
         [key]:value
        })
        
   }
 

   
  

  return (
    <div className="offcanvas offcanvas-end" tabIndex="-1" id="createContactCanvas" aria-labelledby="createContactCanvasLabel">
        <div className="offcanvas-header">
            <h5 className="offcanvas-title" id="createContactCanvasLabel">Create Contact</h5>
            <button type="button" className="slider-close-btn" data-bs-dismiss="offcanvas" onClick={clearData}>
                <img src={sliderCloseIcon} className="img-fluid"/>
            </button>
        </div>
        <div className="offcanvas-body">
            {validationErrors.map((error)=>(
             <Alert  color="danger">
                 {error.error}
             </Alert>
            ))}
       
            <div className="tags mb-3">
                <input type="text" value={newContact.first_name} name="first_name" onChange={handleNewContact} className="form-control slider-inputs" placeholder="First Name" required/>
            </div>
            <div className="tags mb-3">
                <input type="text" value={newContact.last_name} name="last_name" onChange={handleNewContact} className="form-control slider-inputs" placeholder="Last Name" required/>
            </div>
            <div className="tags extra mb-4.5">
                <input type="text" value={encodePhoneNumber(newContact.phone_no)}  name="phone_no" onChange={(e)=>setNewContact({...newContact,phone_no:encodePhoneNumber(e.target.value)})} className="form-control slider-inputs" placeholder="Phone Number" required/>
            </div>
            <AsyncCreatable 
                   options={ options } 
                    isMulti
                    value={newContact.tags}
                    // defaultValue={number}
                   
                    placeholder='Tags'
                    onChange = { onSelectChange }
                    
                />
            <div className="d-flex justify-content-end mt-4">
                <button className="slider-cancel-btn me-2" data-bs-dismiss="offcanvas" onClick={clearData}>Cancel</button>
                <button className="slider-success-btn" data-bs-dismiss="offcanvas" onClick={handleSubmit}>Save</button>
            </div>
        </div>
    </div>
   
  )
}
